import { LifestyleService } from "@/clients/services/LifestyleService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetLifestyle = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.LIFESTYLE],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await LifestyleService.getLifestyleApiV1LifestyleGet(
        user.id,
      );

      return data;
    },
  });

  return {
    lifestyle: data,
    isLoading,
    isError,
    error,
  };
};
